import { Rect } from "../../MyHelpers";
import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { ExpandingWildsBulk, ExpandingWildsBulkConfig, ExpandingWildsBulkFactory, ExpandingWildsBulkParam } from "../ExpandingWildBulk";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { SlotGameType1 } from "../SlotGameType1";
// namespace SlotGames
// {

export class BambooSecretsFillingPot extends SlotGameType1 {
	//SEND COLOR 
	// protected override color: RewardColor =
	// 	{
	// 		color: "yellow",
	// 		coloroutherStroke: "black",
	// 		colorinnerStroke: "red",
	// 	}

	//LED COLOR
	protected override ColorLed: string = "255,255,0\n";

	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "BambooSecretsFillingPot");;

		//this.spinnableReelsParams.topBorderWidth = 7;
		//this.spinnableReelsParams.bottomBorderWidth = 7;
		//this.fillingPotFeature?.SetSkin(this.skinAttachmentFillingPotFeature);
	}
}